var map = {
	"./bin-hover.svg": "8025",
	"./bin.svg": "be15",
	"./checkmark.svg": "9194",
	"./collapse.svg": "32ff",
	"./cross.svg": "b706",
	"./dots.svg": "4734",
	"./elapse.svg": "50f5",
	"./inclination.svg": "660f",
	"./navigation.svg": "cef0",
	"./norecord.svg": "680d",
	"./pencil-hover.svg": "b3e7",
	"./pencil.svg": "4145",
	"./plus.svg": "6a57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e8c";